// extracted by mini-css-extract-plugin
export default {"expandableTextarea":"ExpandableTextarea_expandableTextarea__v1tFY","emptyTextArea":"ExpandableTextarea_emptyTextArea__ce6YY","charCount":"ExpandableTextarea_charCount__w72oy"};